import React, { ComponentPropsWithRef, FC } from 'react'

import {
  CommonContentSelectLayout,
  CommonContentUploadFile,
  CommonContentAnnotation,
  DeleteCommonContentPage,
} from 'src/components/organisms'

import { CommonContentPageEntity } from 'src/types'

type DivProps = ComponentPropsWithRef<'div'>
type Props = DivProps & {
  commonContent: CommonContentPageEntity
}

export const CommonContent: FC<Props> = ({ commonContent, ...otherProps }) => {
  return (
    <div {...otherProps}>
      <div className="tw-grid tw-gap-s2">
        <CommonContentSelectLayout commonContent={commonContent} />
        <CommonContentUploadFile commonContent={commonContent} />
        <CommonContentAnnotation commonContent={commonContent} />
        <DeleteCommonContentPage commonContent={commonContent} className="tw-ml-auto tw-w-fit" />
      </div>
    </div>
  )
}
